module.exports = __webpack_public_path__ + "static/media/UnionMini.71816e80.svg";